class AltoTabScroll extends HTMLElement {
  connectedCallback() {
    this.strip = this.querySelector('[data-tab-strip]');
    if (!this.strip) return;

    this.handleClick = this.handleClick.bind(this);
    this.strip.addEventListener('click', this.handleClick);

    // Bring the active tab into view (centered) when the strip overflows.
    const activeTab = this.strip.querySelector('[aria-current="page"]');
    if (activeTab && this.strip.scrollWidth > this.strip.clientWidth) {
      const tabRect = activeTab.getBoundingClientRect();
      const stripRect = this.strip.getBoundingClientRect();
      const offset = tabRect.left - stripRect.left - (this.strip.clientWidth - tabRect.width) / 2;
      this.strip.scrollLeft += offset;
    }
  }

  disconnectedCallback() {
    this.strip?.removeEventListener('click', this.handleClick);
  }

  // Route a category-tab click through the filters drawer's AJAX renderPage so
  // the grid (and this strip) update without a full reload. Treats the tab as a
  // single-select facet: it replaces any current product_type value, keeping all
  // other active filters and the sort untouched. Falls back to plain navigation
  // (the anchor's href) when the drawer or its renderPage isn't available.
  handleClick(event) {
    if (event.defaultPrevented) return;
    // Honour modifier-clicks / non-left-clicks so users can still open in a new tab.
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }

    const link = event.target.closest('[data-tab-link]');
    if (!link || !this.strip.contains(link)) return;

    const drawer = document.querySelector('alto-filters-drawer');
    if (!drawer || typeof drawer.renderPage !== 'function') return;

    event.preventDefault();

    const params = new URLSearchParams(window.location.search);
    params.delete('filter.p.product_type');
    const value = link.dataset.tabValue;
    if (value) params.append('filter.p.product_type', value);

    drawer.renderPage(params.toString(), true);
  }
}

if (!customElements.get('alto-tab-scroll')) {
  customElements.define('alto-tab-scroll', AltoTabScroll);
}
